import { createFileRoute, redirect } from "@tanstack/react-router";

// Folded into the state-wide conveyancing page: we have no Wide Bay office and the
// old page only ever surfaced for other firms' brand names.
export const Route = createFileRoute("/hervey-bay")({
  beforeLoad: () => {
    throw redirect({ href: "/conveyancing/hervey-bay", statusCode: 301 });
  },
});
